(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["reviews-page-overview"] && !Shopify.designMode) return;
  try {
    function updateReviewsWidget(data) {
    const { review_count, average_rating, stats } = data;
    const { ratings } = stats;

    // Calculate total ratings for percentages
    const totalRatings = Object.values(ratings).reduce((sum, count) => sum + count, 0);

    // Update average rating display
    const ratingDisplay = document.querySelector('.rating-display');
    if (ratingDisplay) {
      ratingDisplay.textContent = `${parseFloat(average_rating).toFixed(1)} out of 5`;
    }

    // Update review count
    const reviewCount = document.querySelector('.review-count');
    if (reviewCount) {
      reviewCount.textContent = `${review_count} Ratings`;
    }

    // Update star display
    updateStarDisplay(parseFloat(average_rating));

    // Update rating distribution bars
    updateRatingBars(ratings, totalRatings);
  }

  function updateStarDisplay(rating) {
    const starContainer = document.querySelector('.star-display');
    if (!starContainer) return;

    const fullStars = Math.floor(rating);
    const hasHalfStar = rating % 1 >= 0.5;

    let starsHtml = '';
    for (let i = 1; i <= 5; i++) {
      const fillColor = i <= fullStars || (i === fullStars + 1 && hasHalfStar) ? 'var(--common-star-color)' : '#d1d5db';

      starsHtml += `
        <svg width="22" height="22" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M16.0949 9.98513C16.0949 9.86448 16.1461 9.76863 16.2469 9.69757L20 7.07982V6.2783C20 6.2783 17.1344 6.29648 13.7564 6.23203C13.6837 2.75657 13.7234 0.00165262 13.7234 0.00165262H12.9218L10.2727 3.75475C10.2016 3.85721 10.1058 3.90679 9.98513 3.90679C9.86448 3.90679 9.76863 3.85556 9.69757 3.75475L7.07817 0H6.27665C6.27665 0 6.29483 2.85738 6.23038 6.23038C2.85738 6.29483 0 6.27665 0 6.27665V7.07817L3.7531 9.69592C3.85556 9.76698 3.90514 9.86283 3.90514 9.98347C3.90514 10.1041 3.85391 10.2 3.7531 10.271L0 12.9218V13.7234C0 13.7234 2.75492 13.6837 6.23038 13.7564C6.29648 17.1344 6.27665 20 6.27665 20H7.07817L9.69757 16.2469C9.76863 16.1444 9.86448 16.0949 9.98513 16.0949C10.1058 16.0949 10.2016 16.1461 10.2727 16.2469L12.9218 20H13.7234C13.7234 20 13.6837 17.2385 13.7564 13.7564C17.2385 13.6837 20 13.7234 20 13.7234V12.9218L16.2469 10.2727C16.1461 10.2016 16.0949 10.1058 16.0949 9.98513Z" fill="${fillColor}"/>
        </svg>`;
    }

    starContainer.innerHTML = starsHtml;
  }

  function updateRatingBars(ratings, totalRatings) {
    for (let star = 1; star <= 5; star++) {
      const count = ratings[star] || 0;
      const percentage = totalRatings > 0 ? Math.round((count / totalRatings) * 100) : 0;

      // Update bar width
      const bar = document.querySelector(`[data-star="${star}"] .rating-bar`);
      if (bar) {
        bar.style.width = `${percentage}%`;
      }

      // Update percentage text
      const percentText = document.querySelector(`[data-star="${star}"] .rating-percentage`);
      if (percentText) {
        percentText.textContent = `${percentage}%`;
      }
    }
  }

  async function fetchRatings() {
    const myHeaders = new Headers();
    myHeaders.append('accept', 'application/json');

    const requestOptions = {
      method: 'GET',
      headers: myHeaders,
      redirect: 'follow',
    };

    const response = await fetch(
      `https://api.reviews.io/reviews?store=www.motherroot.london&type=product_review&sku=${window.variants_skus}&include_unpublished_photos=false&include_product_images=false&include_product_reviews=true&include_local_reviews=true&include_subrating_breakdown=false&must_have_body=false`,
      requestOptions
    );

    const data = await response.json();

    console.log(data);

    // Update the widget with real data
    updateReviewsWidget(data);

    return data;
  }

  fetchRatings();
  } catch(e) { console.error(e); }
})();

})();
